import { createSelector } from "reselect";
import { AppState } from "../appState";
import { IFilterDropdown } from "../overagesFilterFormActions";

// Base selector to access commodity state
const commoditySelector = (state: AppState) => state.commodityMasterData;

// Memoized selector to get commodity details

// Memoized selector to transform the data
export const commodityDisplayValueSelector = createSelector(
  [commoditySelector],
  (commodityMasterData): string[] =>
    commodityMasterData
      .map((item: IFilterDropdown) => item.displayValue)
      .sort((a: string, b: string) => a.localeCompare(b))
);

// Memoized selector to get full commodity objects sorted by code
export const commodityMasterDataSelector = createSelector(
  [commoditySelector],
  (commodityMasterData): IFilterDropdown[] =>
    [...commodityMasterData].sort((a: IFilterDropdown, b: IFilterDropdown) =>
      (a.code ?? "").localeCompare(b.code ?? "")
    )
);
